import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {
  setSQFTActiveButton,
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  setSQFTSystemMessage
} from "../../../../../../../../actions/sqftMenuFunctions";
import {updateSQFTCalculations} from "../../../../../../../../actions/sqftFunctions";
import {SIDEBAR_HIDDEN_BUTTONS} from "../../../../../../constants";
import backsplashCanvas from "../../../../../canvas/core/controls/backsplashCanvas";
import sqftConfig from "../../../../../canvas/store/sqftConfig";

const SqftNavBacksplashesCustomButton = (props) => {
  const { intl, selectedBacksplash, setSelectedBacksplash, setSQFTActiveSubMenuButton } = props;

  const edgeClick = (e) => {
    void e;
    setSelectedBacksplash(SIDEBAR_HIDDEN_BUTTONS.buttonCustomBacksplash);
    setSQFTActiveSubMenuButton(SIDEBAR_HIDDEN_BUTTONS.buttonCustomBacksplash);
    backsplashCanvas.setHighlighting(true);
    backsplashCanvas.setBackSplashFeature({
      size: sqftConfig.measureUnit === "Imperial" ? 15 : 300,
      name: intl.formatMessage({id: "sqft.navigation.submenu.customBacksplash"}), // note this is used to filter backsplashes
    });
    backsplashCanvas.setCursorImage();

  };

  return (
    <li className={"lightbox-option-round lightbox-option-round--edge " + ( selectedBacksplash === SIDEBAR_HIDDEN_BUTTONS.buttonCustomBacksplash ? "lightbox-option-selected" : "" )}
        onClick={edgeClick}>
      <div className="lightbox-option-round-loader-edge lightbox-option-round-loader-backsplash"/>
      <div className="lightbox-description-text lightbox-description-text--edge">
        <FormattedMessage id={"sqft.navigation.submenu.customBacksplash"}/>
      </div>
    </li>
  )
};

SqftNavBacksplashesCustomButton.propTypes = {
};

const mapStateToProps = (store) => ({
  updateCalculations: store.sqftState.updateCalculations,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setSQFTSystemMessage,
  updateSQFTCalculations,
  setSQFTActiveSubMenuButton,
  setSQFTActiveButton,
  setSQFTMenuOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavBacksplashesCustomButton)
);
